export const REDUCER_NAME = 'LoanSchedule'

export const REBUILD_SCHEDULE_MODAL = 'REBUILD_SCHEDULE_MODAL'

export const actions = {
  INITIALIZE: 'LoanSchedule/INITIALIZE',
  TOGGLE_SHOW_OLD_GRAPHIC: 'LoanSchedule/TOGGLE_SHOW_OLD_GRAPHIC',
  SWITCH_OLD_GRAPHIC: 'LoanSchedule/SWITCH_OLD_GRAPHIC',
  FETCH: 'LoanSchedule/FETCH',
  FETCH_SUCCESS: 'LoanSchedule/FETCH_SUCCESS',
  FETCH_FAILURE: 'LoanSchedule/FETCH_FAILURE',
}
